import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import {
  loadSuccess,
  loadFailure,
  loadRequest,
  etapaNotaRequest,
  etapaNotaSuccess,
  etapaNotaFailure,
  itensNotaRequest,
  itensNotaSuccess,
  itensNotaFailure,
} from './actions';

export function* loadMovimentacoes({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();

    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getNotasPrincipal&pagina=${
        payload.pagination ? payload.pagination?.current - 1 : 0
      }&tamanhoPagina=${payload.pagination ? payload.pagination?.pageSize : 5}&token=${
        state.auth.token
      }`,
      {
        filtro: payload.filtro,
        inscricoesEstaduais: payload.inscricaoAtiva,
        centroDistribuicao: payload.cddAtivo,
        ordenacao: payload.sorter,
      }
    );

    yield put(
      loadSuccess(response.data.notas, {
        total: response.data.total,
        current: payload.pagination?.current || 0 + 1,
        pageSize: payload.pagination?.pageSize || 5,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
      })
    );
  } catch (error: any) {
    yield put(loadFailure());

    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar as movimentações, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}

export function* loadEtapas({ payload }: ReturnType<typeof etapaNotaRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getEtapasNota&token=${state.auth.token}`,
      {}
    );
    yield put(etapaNotaSuccess(response.data.etapas));
  } catch (err) {
    yield put(etapaNotaFailure());
    Swal.fire({ title: 'Não foi possivel carregar os etapas de nota!', html: '', icon: 'warning' });
  }
}

export function* loadItensNotaEntrada({ payload }: ReturnType<typeof itensNotaRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getItensNota&token=${state.auth.token}`,
      { nuNota: payload.nuNota }
    );

    yield put(itensNotaSuccess(response.data.itensNota));
  } catch (err) {
    yield put(itensNotaFailure());
    Swal.fire({
      title: 'Não foi possivel carregar os itens da nota, por favor tente novamente!',
      html: '',
      icon: 'warning',
    });
  }
}
